import { ILayoutOptions } from '@app/pages/cmms/interfaces/layout.interfaces';
import { iconEnum } from '@app/configs/model/IconEnum';

export const CMMS_LAYOUT_OPTIONS = (
	disableCalendar: boolean = false,
	disableList: boolean = false
): ILayoutOptions[] => {
	return [
		{
			icon: iconEnum.tableView,
			layoutType: 'table',
			tooltip: 'table',
			disabled: false,
		},
		{
			icon: disableList ? iconEnum.list_view_disabled : iconEnum.list_view,
			layoutType: 'list',
			tooltip: disableList ? 'list_view_is_disabled' : 'list',
			disabled: disableList,
		},
		{
			icon: disableCalendar ? iconEnum.calendar_disabled : iconEnum.calendar_v2,
			layoutType: 'calendar',
			tooltip: disableCalendar ? 'calendar_disabled_status' : 'calendar_view',
			disabled: disableCalendar,
		},
	];
};
